// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"177fd883","214":"6755368a","372":"cc4a3759"}[chunkId] + ".css";
};